/*! Copyright (c) Safe As Milk. All rights reserved. */
const STATES = [ "IDLE", "DOING", "DONE" ];

class StagedAction extends HTMLElement {
    #tick;
    #duration=1500;
    constructor() {
        super();
        this.#tick = this.querySelector("staged-action-tick");
    }
    setState(state = STATES[0]) {
        return new Promise(((resolve, reject) => {
            const persistDone = this.hasAttribute("persist-done");
            if (!STATES.includes(state)) reject(new Error("Invalid state"));
            if (state === STATES[0]) {
                this.classList.remove("is-done");
                this.classList.remove("is-doing");
                this.classList.remove("is-done-persistent");
                resolve("Idle");
            }
            if (state === STATES[1]) {
                this.classList.remove("is-done");
                this.classList.remove("is-done-persistent");
                this.classList.add("is-doing");
                resolve("Doing");
            }
            if (state === STATES[2]) {
                this.classList.remove("is-doing");
                this.classList.remove("is-done-persistent");
                this.classList.add("is-done");
                const tickAnimations = this.#tick.getAnimations();
                const finalizeDone = () => {
                    this.classList.remove("is-done");
                    if (persistDone) {
                        this.classList.add("is-done-persistent");
                    }
                    resolve("Done");
                };
                if (tickAnimations.length > 0) {
                    this.#tick.addEventListener("animationend", finalizeDone, {
                        once: true
                    });
                } else {
                    setTimeout(finalizeDone, this.#duration);
                }
            }
        }));
    }
}

customElements.define("staged-action", StagedAction);
//# sourceMappingURL=staged-action.js.map
